import React, { useContext, useRef, useState, useEffect } from 'react';
import './Navbar.css';
import logo from '../Assets/logo.png';
import cart_icon from '../Assets/cart_icon.png';
import { Link } from 'react-router-dom';
import { ShopContext } from '../../Context/ShopContext';
import nav_dropdown from '../Assets/nav_dropdown.png';

const Navbar = () => {
  const [menu, setMenu] = useState('shop');
  const { getTotalCartItems } = useContext(ShopContext);
  const menuRef = useRef();
  const [userName, setUserName] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('auth-token');
    if (token) {
      fetch('http://localhost:4000/user', {
        headers: { 'auth-token': token }
      })
        .then(res => {
          if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
          return res.json();
        })
        .then(data => {
          if (data.success && data.user) {
            const userName = data.user.name;
            localStorage.setItem('user-name', userName);
            setUserName(userName);
          }
        })
        .catch(err => console.error("Error fetching user:", err));
    }
  }, []);

  const dropdown_toggle = (e) => {
    menuRef.current.classList.toggle('nav-menu-visible');
    e.target.classList.toggle('open');
  };

  return (
    <div className='navbar'>
      <div className='nav-logo'>
        <img src={logo} alt="" />
        <p>SHOPPER</p>
      </div>
      <img onClick={dropdown_toggle} className='nav-dropdown' src={nav_dropdown} alt="" />
      <ul ref={menuRef} className="nav-menu">
        <li onClick={() => { setMenu('shop'); }}><Link style={{ textDecoration: 'none' }} to='/'>Shop</Link>{menu === 'shop' ? <hr /> : <></>}</li>
        <li onClick={() => { setMenu('mens'); }}><Link style={{ textDecoration: 'none' }} to='mens'>Men</Link>{menu === 'mens' ? <hr /> : <></>}</li>
        <li onClick={() => { setMenu('womens'); }}><Link style={{ textDecoration: 'none' }} to='womens'>women</Link>{menu === 'womens' ? <hr /> : <></>}</li>
        <li onClick={() => { setMenu('kids'); }}><Link style={{ textDecoration: 'none' }} to='kids'>kids</Link>{menu === 'kids' ? <hr /> : <></>}</li>
        <li onClick={() => { setMenu('orders'); }}><Link style={{ textDecoration: 'none' }} to='orders'>Orders</Link>{menu === 'orders' ? <hr /> : <></>}</li> {/* إضافة رابط Orders */}
      </ul>
      <div className='nav-login-cart'>
        {localStorage.getItem('auth-token') ? (
          <>
            <span className="nav-welcome">Welcome: {userName || 'User'}</span>
            <button onClick={() => { localStorage.removeItem('auth-token'); localStorage.removeItem('user-name'); window.location.replace('/'); }}>Logout</button>
          </>
        ) : (
          <Link to='/login'><button>Login</button></Link>
        )}
        <Link to='/cart'><img src={cart_icon} alt="" /></Link>
        <div className="nav-cart-count">{getTotalCartItems()}</div>
      </div>
    </div>
  );
};

export default Navbar;